
export const API_URL = 'https://satyr.nl/pic/gallery.php'
export const API_LOGIN = 'user_5432123'
export const API_PASS = "3fSt4j4ncsy7456hu02r82urda2s4fdfbg35ocsijwew28"
export const IMG_URL = 'https://satyr.nl/pic';
export const BASE_URL = '/pic'; //'/galeria'
